import { memo } from "react";
import { AccordionContainer } from "@app/shared/AccordionContainer";
import { ProviderNetworkImportGridGroup } from "@app/provider-network-imports/components/ProviderNetworkImportGridGroup";
import { useImportConfig } from "@app/provider-network-imports/hooks/useImportConfig";

function nonMemoProviderNetworkImportGrid() {
  const { getConfiguredGroups } = useImportConfig();

  const importConfigGroups = getConfiguredGroups().map((group) => {
    return (<ProviderNetworkImportGridGroup key={group} group={group} />);
  });

  return (
    <div className="pt-2">
      <AccordionContainer>{importConfigGroups}</AccordionContainer>
    </div>
  );
}

export const ProviderNetworkImportGrid = memo(nonMemoProviderNetworkImportGrid);
